import { render, staticRenderFns } from "./DeleteDocument.vue?vue&type=template&id=3ae58236&"
import script from "./DeleteDocument.vue?vue&type=script&lang=js&"
export * from "./DeleteDocument.vue?vue&type=script&lang=js&"
import style0 from "./DeleteDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ae58236')) {
      api.createRecord('3ae58236', component.options)
    } else {
      api.reload('3ae58236', component.options)
    }
    module.hot.accept("./DeleteDocument.vue?vue&type=template&id=3ae58236&", function () {
      api.rerender('3ae58236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/document/DeleteDocument.vue"
export default component.exports